<template>
  <div class="md-layout">
    <md-card>
      <md-card-header
        v-if="!everythingLoaded"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon class="load-rotate">hourglass_empty</md-icon>
        </div>
        <h4 class="title">Avatar uploaden</h4>
      </md-card-header>
      <md-card-header
        v-if="everythingLoaded"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon>photo</md-icon>
        </div>
        <h4 class="title">Avatar</h4>
      </md-card-header>
      <md-card-content
        class="avatar-container"
        :class="[{ loading: !everythingLoaded }, { '': everythingLoaded }]"
      >
        <div class="imagePreview" :src="imageUrl" :style="style" />
        <file-picker
          v-model="fileData"
          :label="labelPicker"
          :class-name="[
            { 'md-success': fileData === null },
            { 'md-primary': fileData !== null }
          ]"
          content-types="image/*"
        ></file-picker>
        <md-button
          v-if="fileData !== null"
          native-type="button"
          class="md-success"
          @click.native.prevent="uploadAvatar"
          :disabled="disableButton"
          >{{ labelUpload }}</md-button
        >
      </md-card-content>
      <md-card-actions> </md-card-actions>
    </md-card>
  </div>
</template>
<script>
import filePicker from "../Files/FilePicker.vue";

export default {
  components: {
    filePicker
  },
  props: ["labelPicker", "labelUpload"],
  data() {
    return {
      fileData: {
        fileData: null,
        filename: null
      },
      disableButton: false
    };
  },
  computed: {
    imageUrl: function() {
      if (this.fileData.fileData === null) {
        return (
          this.$apiBaseUrl + "../user/" + this.$route.params.id + "/avatar"
        );
      }
      return this.fileData.fileData;
    },
    style: function() {
      return "background-image: url(" + this.imageUrl + ")";
    },
    everythingLoaded: function() {
      return !this.disableButton;
    }
  },
  watch: {
    fileData() {
      this.$emit("input", this.fileData);
    }
  },
  methods: {
    uploadAvatar() {
      this.disableButton = true;
      this.$http
        .post(
          this.$apiBaseUrl + "user/" + this.$route.params.id + "/avatar",
          Object.assign({
            fileData: this.fileData.fileData,
            filename: this.fileData.filename
          })
        )
        .then(
          response => {
            this.fileData.fileData = null;
            this.fileData.filename = null;
            this.disableButton = false;
            this.notifyVue(
              "Chauffeur foto succesvol opgeslagen",
              "check",
              "success",
              5000
            );
          },
          response => {
            this.disableButton = false;
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur foto",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
div.avatar-container {
  padding: 15px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;

  &.loading {
    cursor: wait !important;
  }

  div.imagePreview {
    border: 1px solid #999;
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    margin-bottom: 15px;
  }
}
</style>
